module.exports = __webpack_public_path__ + "static/media/Img_10.e14d3955.JPG";